import { useContext, useEffect } from "react";
import { Table } from "react-bootstrap";
import { isEmpty } from "lodash";
import { useSelector } from "react-redux";

import SiteTitle from "../../../utils/SiteTitle/SiteTitle";
import EmptyData from "../../../utils/EmptyData/EmptyData";
import CardLayout from "../../../utils/CardLayout/CardLayout";
import CustomModal from "../../../utils/CustomModal/CustomModal";
import ItemInfo from "../../../utils/ItemInfo/ItemInfo";
import PaginationList from "../../../utils/PaginationList/PaginationList";
import { userSatisfactionAdminContext } from "../../../context/Admin/UserSatisfactionAdminContext/UserSatisfactionAdminContext";
import { areYouSureMessage } from "../../../utils/toastMessage/toastMessage";

const UserSatisfactionAdmin = () => {
  const appConfigs = useSelector((state) => state.appConfigs);
  const permission = useSelector((state) => state.permission);

  const {
    userSatisfactionItems,
    userSatisfaction,
    icon,
    setIcon,
    id,
    description,
    setDescription,
    isShowModal,
    isShowDetailsModal,
    limit,
    setLimit,
    totalCount,
    pageNumber,
    setPageNumber,
    handleShowDetailsModal,
    handleCloseDetailsModal,
    handleShowModal,
    handleCloseModal,
    handleGetUserSatisfactionItemList,
    handleCreateUserSatisfactionItem,
    handleEditUserSatisfactionItem,
    handleDeleteUserSatisfactionItem,
  } = useContext(userSatisfactionAdminContext);

  useEffect(() => {
    handleGetUserSatisfactionItemList();
  }, [pageNumber, limit]);

  return (
    <>
      <SiteTitle title="آیتم های رضایت کاربر" />

      <CardLayout>
        {permission.customer_satisfaction_create && (
          <div className="mb-2">
            <button
              className="btn btn-success"
              onClick={() => handleShowModal()}
            >
              <i className="fa fa-plus mr-2" />
              افزودن
            </button>
          </div>
        )}
        {isEmpty(userSatisfactionItems) ? (
          <EmptyData />
        ) : (
          <>
            <div className="d-flex justify-content-between align-items-center">
              <PaginationList
                setPageNumber={setPageNumber}
                pageCount={totalCount / limit}
              />
              <div>
                <select
                  className="form-control mb-3"
                  onChange={(e) => setLimit(Number(e.target.value))}
                >
                  <option value={10} selected={10 === limit}>
                    10
                  </option>
                  <option value={25} selected={25 === limit}>
                    25
                  </option>
                  <option value={50} selected={50 === limit}>
                    50
                  </option>
                  <option value={75} selected={75 === limit}>
                    75
                  </option>
                  <option value={100} selected={100 === limit}>
                    100
                  </option>
                </select>
              </div>
            </div>
            <Table responsive hover borderless striped>
              <thead className="thead-dark">
                <tr>
                  <th>#</th>
                  <th>شناسه</th>
                  <th>توضیحات</th>
                  <th>آیکن</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {userSatisfactionItems.map((_item, index) => (
                  <tr>
                    <td>{index + 1}</td>
                    <td>{_item.id}</td>
                    <td>{_item.description}</td>
                    <td>{_item.icon}</td>
                    <td className="mw-25">
                      {/* <button
                        onClick={() => handleShowDetailsModal(_item)}
                        className="btn btn-info mr-2"
                      >
                        جزئیات
                      </button> */}
                      {permission.customer_satisfaction_update && (
                        <button
                          onClick={() => handleShowModal(_item)}
                          className="btn btn-primary mr-2"
                        >
                          جزئیات و ویرایش
                        </button>
                      )}
                      {permission.customer_satisfaction_delete && (
                        <i
                          onClick={() =>
                            areYouSureMessage(
                              () => handleDeleteUserSatisfactionItem(_item.id),
                              `آیا از حذف آیتم رضایت کاربر ${_item.id} اطمینان دارید؟`
                            )
                          }
                          className="fa fa-trash-alt fa-2x text-danger cursorPointer"
                        />
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}
      </CardLayout>

      {/* Start Create Modal */}
      <CustomModal
        title={`${id ? "ویرایش" : "افزودن"} آیتم رضایت کاربر`}
        show={isShowModal}
        onHide={handleCloseModal}
      >
        <form
          onSubmit={
            id
              ? handleEditUserSatisfactionItem
              : handleCreateUserSatisfactionItem
          }
          autoComplete="off"
        >
          <div className="row">
            <div className="col-12 mb-2">
              <label htmlFor="description">توضیحات</label>
              <textarea
                id="description"
                name="description"
                className="form-control"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
            <div className="col-12 mb-2">
              <label htmlFor="icon">آیکن</label>
              <input
                type="text"
                id="icon"
                name="icon"
                className="form-control"
                value={icon}
                onChange={(e) => setIcon(e.target.value)}
              />
            </div>
            <div className="col-12 mb-2">
              <label>پیشنمایش آیکن</label>
              <div className="text-center">
                {icon && icon.length > 3 ? (
                  <img
                    src={`${appConfigs.APP_DOWNLOAD_LINK}/static/console/${icon}`}
                    alt={icon}
                    className="img-fluid img-thumbnail rounded"
                  />
                ) : (
                  <p className="alert alert-info m-0">آیکنی وارد نشده است</p>
                )}
              </div>
            </div>
          </div>
          <hr />
          <button className="btn btn-primary btn-block" type="submit">
            <i className="fas fa-check mr-2" /> {id ? "ویرایش" : "افزودن"}
          </button>
        </form>
      </CustomModal>
      {/* End Create Modal */}

      {/* Start Details Modal */}
      <CustomModal
        title="جزئیات آیتم رضایت کاربر"
        show={isShowDetailsModal}
        onHide={handleCloseDetailsModal}
        size="xl"
      >
        <div className="container">
          <div className="row">
            <ItemInfo label="شناسه">
              <p>{userSatisfaction.id}</p>
            </ItemInfo>
            <ItemInfo label="توضیحات">
              <p>{userSatisfaction.description}</p>
            </ItemInfo>
            <ItemInfo label="آیکن">
              <p>{userSatisfaction.icon}</p>
            </ItemInfo>
            <ItemInfo label="پیشنمایش آیکن">
              <p className="text-center">
                <img
                  src={`${appConfigs.APP_DOWNLOAD_LINK}/static/console/${userSatisfaction.icon}`}
                  alt={userSatisfaction.icon}
                  className="img-fluid img-thumbnail rounded"
                />
              </p>
            </ItemInfo>
          </div>
        </div>
      </CustomModal>
      {/* End Details Modal */}
    </>
  );
};

export default UserSatisfactionAdmin;
